import React, { useMemo, useState } from "react";
import { Windows } from "./Menu";
import { Link } from "react-router-dom";
import { BsChevronDown, BsChevronRight, BsSearch } from "react-icons/bs";
import {
  clearBreadCumb,
  resetBreadCumb,
} from "../../../middlewares/breadCrumb/BreadCrumb";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import { clearRoutingHistory } from "../../../middlewares";

const DropDown = () => {
  const {
    sysAdmin: { role },
    selectedMenu,
    setSelectedMenu,
    setSingleAdmin,
  } = useAdminContext();

  const [query, setQuery] = useState("");

  // Search (visual only)
  const filteredWindows = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return Windows;
    return Windows.filter((w) => {
      const titleMatch = w.title?.toLowerCase().includes(q);
      const childMatch = w.menu?.some((m) => m.title?.toLowerCase().includes(q));
      return titleMatch || childMatch;
    });
  }, [query]);

  return (
    <div className="flex flex-col gap-3">
      {/* Search */}
      <div className="relative">
        <BsSearch className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          value={query}
          placeholder="Search menu…"
          onChange={(e) => setQuery(e.target.value)}
          className="w-full rounded-xl border border-gray-200 bg-white/90 py-2.5 pl-9 pr-3 text-sm text-gray-900 placeholder:text-gray-400 shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200"
        />
      </div>

      {/* Groups */}
      <nav className="flex flex-col gap-2 text-xs">
        {filteredWindows?.map(({ title, menu, icon, roles }, key) => {
          if (!roles?.includes(role)) return null;
          const open = selectedMenu === key;
          const sectionId = `menu-section-${key}`;

          return (
            <section
              key={key}
              className="group/section rounded-2xl border border-gray-200 bg-white shadow-sm"
            >
              {/* Group header */}
              <button
                type="button"
                onClick={() => setSelectedMenu(open ? null : key)}
                aria-controls={sectionId}
                aria-expanded={open}
                className={[
                  "flex w-full items-center justify-between rounded-2xl px-3.5 py-3 transition-colors",
                  open
                    ? "bg-gray-900 text-white"
                    : "bg-white text-gray-800 hover:bg-gray-50",
                ].join(" ")}
              >
                <span className="flex min-w-0 items-center gap-2">
                  <span className={open ? "text-white" : "text-gray-700"}>{icon}</span>
                  <span className="truncate text-[13px] font-semibold">{title}</span>
                </span>
                <span className="shrink-0 rounded-md border border-gray-200 bg-white/90 p-1">
                  {open ? <BsChevronDown className="h-4 w-4 text-black" /> : <BsChevronRight className="h-4 w-4" />}
                </span>
              </button>

              {/* Children */}
              <div
                id={sectionId}
                className={[
                  "grid overflow-hidden transition-[grid-template-rows] duration-300 ease-out",
                  open ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
                ].join(" ")}
              >
                <div className="min-h-0">
                  <div className="border-t border-gray-100" />
                  <ul className="flex flex-col gap-1 px-2.5 py-2">
                    {menu?.map(({ ref, title: mTitle, roles: mRoles }, idx) => {
                      if (mRoles && !mRoles?.includes(role)) return null;
                      return (
                        <li key={idx} className="min-w-0">
                          <Link
                            to={ref}
                            onClick={() => {
                              clearBreadCumb();
                              resetBreadCumb();
                              setSingleAdmin(null);
                              clearRoutingHistory();
                            }}
                            className="group flex items-center justify-between rounded-xl px-2.5 py-2 text-[13px] text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                          >
                            <span className="truncate">{mTitle}</span>
                            <span className="opacity-0 transition-opacity group-hover:opacity-100 text-[10px] text-gray-500">
                              Open
                            </span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </section>
          );
        })}
      </nav>
    </div>
  );
};

export default DropDown;
